import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../App.css';
import logo from '../../assets/logo.png';
import fotoLogin from '../../assets/fotoparalogin.jpg';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await login(email, password);

        if (result.success) {
            const roleName = result.user.role_details?.name;
            if (roleName === 'SUPER_ADMIN' || result.user.is_superuser) {
                navigate('/');
            } else {
                navigate('/fast-food/pos');
            }
        } else {
            setError(result.error);
            setLoading(false);
        }
    };

    return (
        <div className="saio-login">
            <style>
                {`
                .saio-login {
                    --cream: #f2ede4;
                    --cream-dim: rgba(242,237,228,0.62);
                    --cream-faint: rgba(242,237,228,0.14);
                    --amber: #d9a45b;
                    --amber-soft: rgba(217,164,91,0.35);
                    --night: #15100d;
                    --glass: rgba(24,17,13,0.58);
                    --serif: 'Cormorant Garamond', 'Times New Roman', Georgia, serif;
                    --sans: 'Jost', 'Segoe UI', system-ui, sans-serif;

                    position: relative;
                    min-height: 100vh;
                    width: 100%;
                    display: grid;
                    place-items: center;
                    padding: 2rem 1rem;
                    box-sizing: border-box;
                    background: var(--night);
                    color: var(--cream);
                    font-family: var(--sans);
                    overflow: hidden;
                }

                /* ---------- Fondo fotográfico ---------- */
                .saio-login__bg {
                    position: absolute;
                    inset: -2%;
                    width: 104%;
                    height: 104%;
                    object-fit: cover;
                    object-position: center 42%;
                    animation: saio-drift 28s ease-in-out infinite alternate;
                }
                .saio-login__shade {
                    position: absolute;
                    inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 45%, rgba(21,16,13,0.15) 0%, rgba(21,16,13,0.55) 55%, rgba(21,16,13,0.88) 100%),
                        linear-gradient(180deg, rgba(21,16,13,0.35) 0%, rgba(21,16,13,0.15) 50%, rgba(21,16,13,0.55) 100%);
                }
                .saio-login__grain {
                    position: absolute;
                    inset: 0;
                    opacity: 0.06;
                    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>");
                    pointer-events: none;
                }

                /* ---------- Tarjeta de cristal ---------- */
                .saio-login__card {
                    position: relative;
                    width: 100%;
                    max-width: 420px;
                    padding: 3rem 2.75rem 2.5rem;
                    box-sizing: border-box;
                    background: var(--glass);
                    backdrop-filter: blur(18px) saturate(120%);
                    -webkit-backdrop-filter: blur(18px) saturate(120%);
                    border: 1px solid var(--cream-faint);
                    border-radius: 6px;
                    box-shadow:
                        0 40px 80px -30px rgba(0,0,0,0.75),
                        inset 0 1px 0 rgba(242,237,228,0.08);
                    text-align: center;
                    animation: saio-appear 0.9s 0.1s cubic-bezier(.2,.7,.2,1) both;
                }
                /* esquinas finas doradas */
                .saio-login__card::before,
                .saio-login__card::after {
                    content: '';
                    position: absolute;
                    width: 26px;
                    height: 26px;
                    border-color: var(--amber);
                    border-style: solid;
                    opacity: 0.8;
                }
                .saio-login__card::before {
                    top: 10px; left: 10px;
                    border-width: 1px 0 0 1px;
                }
                .saio-login__card::after {
                    bottom: 10px; right: 10px;
                    border-width: 0 1px 1px 0;
                }

                .saio-login__logo {
                    width: 96px;
                    height: 96px;
                    border-radius: 50%;
                    object-fit: contain;
                    margin: -5.5rem auto 1.5rem;
                    display: block;
                    box-shadow:
                        0 0 0 6px var(--night),
                        0 0 0 7px var(--amber-soft),
                        0 20px 40px -12px rgba(0,0,0,0.8);
                }
                .saio-login__title {
                    font-family: var(--serif);
                    font-weight: 500;
                    font-size: 2.35rem;
                    line-height: 1;
                    letter-spacing: 0.02em;
                    color: var(--cream);
                    margin: 0 0 0.5rem;
                }
                .saio-login__sub {
                    font-size: 0.68rem;
                    letter-spacing: 0.36em;
                    text-transform: uppercase;
                    color: var(--amber);
                    margin: 0 0 2.25rem;
                }

                .saio-login__error {
                    text-align: left;
                    font-size: 0.85rem;
                    line-height: 1.4;
                    padding: 0.75rem 1rem;
                    margin-bottom: 1.25rem;
                    border: 1px solid rgba(217,120,91,0.45);
                    background: rgba(217,120,91,0.12);
                    color: #f0c4b4;
                    border-radius: 4px;
                }

                .saio-field {
                    text-align: left;
                    margin-bottom: 1.1rem;
                }
                .saio-field label {
                    display: block;
                    font-size: 0.66rem;
                    letter-spacing: 0.28em;
                    text-transform: uppercase;
                    color: var(--cream-dim);
                    margin-bottom: 0.5rem;
                }
                .saio-field__control {
                    position: relative;
                }
                .saio-field input {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0.9rem 1rem;
                    font-family: var(--sans);
                    font-size: 1rem;
                    font-weight: 300;
                    color: var(--cream);
                    background: rgba(242,237,228,0.06);
                    border: 1px solid rgba(242,237,228,0.16);
                    border-radius: 4px;
                    outline: none;
                    transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
                }
                .saio-field input::placeholder { color: rgba(242,237,228,0.32); }
                .saio-field input:hover { border-color: rgba(242,237,228,0.28); }
                .saio-field input:focus {
                    border-color: var(--amber);
                    background: rgba(242,237,228,0.09);
                    box-shadow: 0 0 0 3px rgba(217,164,91,0.18);
                }
                .saio-field input:-webkit-autofill {
                    -webkit-box-shadow: 0 0 0 1000px #2a201a inset;
                    -webkit-text-fill-color: var(--cream);
                    caret-color: var(--cream);
                }
                .saio-field input[type="password"] { letter-spacing: 0.18em; }
                .saio-field__toggle {
                    position: absolute;
                    right: 0.5rem;
                    top: 50%;
                    transform: translateY(-50%);
                    background: none;
                    border: none;
                    padding: 0.4rem;
                    cursor: pointer;
                    color: var(--cream-dim);
                    display: flex;
                    align-items: center;
                    transition: color 0.2s ease;
                }
                .saio-field__toggle:hover { color: var(--amber); }
                .saio-field__toggle svg { width: 18px; height: 18px; }

                .saio-login__btn {
                    width: 100%;
                    margin-top: 1.25rem;
                    padding: 1rem;
                    font-family: var(--sans);
                    font-size: 0.76rem;
                    font-weight: 500;
                    letter-spacing: 0.32em;
                    text-transform: uppercase;
                    color: var(--night);
                    background: var(--cream);
                    border: 1px solid var(--cream);
                    border-radius: 4px;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                    transition: transform 0.2s ease, box-shadow 0.25s ease, background 0.25s ease;
                    box-shadow: 0 16px 34px -14px rgba(242,237,228,0.35);
                }
                .saio-login__btn::after {
                    /* brillo que cruza al pasar el cursor */
                    content: '';
                    position: absolute;
                    top: 0; left: -60%;
                    width: 40%; height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(217,164,91,0.35), transparent);
                    transform: skewX(-20deg);
                    transition: left 0.6s ease;
                }
                .saio-login__btn:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 20px 40px -14px rgba(242,237,228,0.45);
                }
                .saio-login__btn:hover:not(:disabled)::after { left: 120%; }
                .saio-login__btn:active:not(:disabled) { transform: translateY(0); }
                .saio-login__btn:focus-visible {
                    outline: 2px solid var(--amber);
                    outline-offset: 3px;
                }
                .saio-login__btn:disabled {
                    opacity: 0.75;
                    cursor: wait;
                }

                .saio-login__foot {
                    margin: 2rem 0 0;
                    font-size: 0.62rem;
                    letter-spacing: 0.3em;
                    text-transform: uppercase;
                    color: rgba(242,237,228,0.38);
                }

                @keyframes saio-appear {
                    from { opacity: 0; transform: translateY(18px) scale(0.985); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes saio-drift {
                    from { transform: scale(1) translate(0, 0); }
                    to   { transform: scale(1.06) translate(-0.8%, -1%); }
                }
                @media (prefers-reduced-motion: reduce) {
                    .saio-login__bg, .saio-login__card { animation: none; }
                }

                @media (max-width: 480px) {
                    .saio-login { padding: 4.5rem 1rem 2rem; align-items: start; }
                    .saio-login__card { padding: 2.5rem 1.5rem 2rem; }
                    .saio-login__logo { width: 84px; height: 84px; margin-top: -4.9rem; }
                    .saio-login__title { font-size: 2rem; }
                }
                `}
            </style>

            <img className="saio-login__bg" src={fotoLogin} alt="" aria-hidden="true" />
            <div className="saio-login__shade" aria-hidden="true" />
            <div className="saio-login__grain" aria-hidden="true" />

            <main className="saio-login__card">
                <img className="saio-login__logo" src={logo} alt="SAIO SUSHI" />
                <h1 className="saio-login__title">Bienvenido</h1>
                <p className="saio-login__sub">Puré sushi experience</p>

                {error && (
                    <div className="saio-login__error" role="alert">{error}</div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="saio-field">
                        <label htmlFor="email">Correo electrónico</label>
                        <div className="saio-field__control">
                            <input
                                type="email"
                                id="email"
                                autoComplete="username"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="tu@correo.com"
                            />
                        </div>
                    </div>

                    <div className="saio-field">
                        <label htmlFor="password">Contraseña</label>
                        <div className="saio-field__control">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                                style={{ paddingRight: '2.75rem' }}
                            />
                            <button
                                type="button"
                                className="saio-field__toggle"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                tabIndex={-1}
                            >
                                {showPassword ? (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="saio-login__btn" disabled={loading}>
                        {loading ? 'Ingresando…' : 'Ingresar'}
                    </button>
                </form>

                <p className="saio-login__foot">SAIO SUSHI · Sistema de gestión</p>
            </main>
        </div>
    );
};

export default Login;
